import { render, staticRenderFns } from "./ProjectResponseMenuTab.vue?vue&type=template&id=0cf34c8f&scoped=true"
import script from "./ProjectResponseMenuTab.vue?vue&type=script&lang=js"
export * from "./ProjectResponseMenuTab.vue?vue&type=script&lang=js"
import style0 from "./ProjectResponseMenuTab.vue?vue&type=style&index=0&id=0cf34c8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf34c8f",
  null
  
)

export default component.exports